// Processed result display component with download overlay
import React from 'react';
import { Box, Text, Center, Button, Image as ChakraImage } from '@chakra-ui/react';
import { Download } from 'lucide-react';
import { ImageItem } from '../types';

interface ProcessedResultProps {
  currentImage: ImageItem;
  onDownload: () => void;
}

export const ProcessedResult: React.FC<ProcessedResultProps> = ({ currentImage, onDownload }) => {
  if (!currentImage?.processedUrl) return null;

  return (
    <Box
      bg="background.secondary"
      borderRadius="xl"
      p={5}
      border="1px solid"
      borderColor="border.default"
    >
      <Text
        fontSize="xs"
        fontWeight="semibold"
        color="text.secondary"
        textTransform="uppercase"
        letterSpacing="wider"
        fontFamily="secondary"
        mb={4}
      >
        Processed Result
      </Text>
      <Box
        position="relative"
        minH="250px"
        bg="background.tertiary"
        borderRadius="lg"
        p={4}
        _hover={{ '& .download-overlay': { opacity: 1 } }}
      >
        <Center minH="250px">
          <ChakraImage
            src={currentImage.processedUrl}
            maxH="300px"
            maxW="100%"
            objectFit="contain"
            borderRadius="md"
          />
        </Center>
        <Center
          className="download-overlay"
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg="blackAlpha.600"
          borderRadius="lg"
          opacity={0}
          transition="opacity 0.2s"
          cursor="pointer"
          onClick={onDownload}
          backdropFilter="blur(2px)"
        >
          <Button
            height="auto"
            py={4}
            px={8}
            bg="#22c55e" // Matching the green from image more closely if needed, or keep status.success
            _hover={{ bg: '#16a34a', transform: 'translateY(-2px)' }}
            _active={{ transform: 'translateY(0)' }}
            color="white"
            borderRadius="xl"
            boxShadow="xl"
            transition="all 0.2s"
          >
            <Box mr={4}>
              <Download size={24} strokeWidth={2.5} />
            </Box>
            <Box textAlign="left">
              <Text fontSize="lg" fontWeight="bold" lineHeight="1.2" color="white">
                Download Image
              </Text>
              <Text fontSize="xs" opacity={0.9} fontWeight="medium" color="white">
                Ctrl/Cmd + D
              </Text>
            </Box>
          </Button>
        </Center>
      </Box>
    </Box>
  );
};
